var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "allDetail", staticClass: "all-detail-task" },
    _vm._l(_vm.taskDatas, function(item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "progress-box-height",
          class: [
            item.open ? "progress-box-more" : "",
            item.open && item.status < 3 && _vm.isVip()
              ? "progress-box-vipMore"
              : "",
            item.open && item.status < 3 && !_vm.isVip()
              ? "progress-box-more"
              : "",
            item.open && item.status == 3 && !item.itemProgressInfo
              ? "progress-failed-less"
              : "",
            _vm.taskDatas.length > 8 ? "progress-box-overflow" : "progress-box"
          ],
          style: { height: _vm.getHeight(item, index) },
          on: {
            mouseenter: function($event) {
              _vm.hoverCurrent = index
            },
            mouseleave: function($event) {
              _vm.hoverCurrent = -1
            },
            click: function($event) {
              return _vm.collapse(index, item)
            }
          }
        },
        [
          _c("div", { staticClass: "detailed-progress-box" }, [
            item.itemProgressInfo &&
            item.itemProgressInfo.percent &&
            item.itemProgressInfo.percent < 100
              ? _c("div", {
                  class:
                    item.itemProgressInfo && item.itemProgressInfo.percent
                      ? "progress-innerbox"
                      : "",
                  style: { width: item.itemProgressInfo.percent + "%" }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-info" }, [
            _c("div", { staticClass: "task-info-name" }, [
              item.status < 3 && item.status != 0
                ? _c("div", { staticClass: "task-status-name" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.transferring")) + ":")
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.status == 0
                ? _c("div", { staticClass: "task-status-name" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.ready")) + ":")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getTaskStr(item) == "success"
                ? _c("div", { staticClass: "task-status-name status-green" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.cloudTransfer.transferSucces")) +
                        ":"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              item.status == 3
                ? _c("div", { staticClass: "task-status-name status-grey" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.canceled")) + ":")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getTaskStr(item) == "success8"
                ? _c("div", { staticClass: "task-status-name status-blue" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.common.partialSuccess")) + ":"
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getTaskStr(item) == "error"
                ? _c("div", { staticClass: "task-status-name status-grey" }, [
                    _vm._v(_vm._s(_vm.$t("language.common.failure")) + ":")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "detailed-sources-name",
                  attrs: { title: item.sourceFilename }
                },
                [_vm._v(" " + _vm._s(item.sourceFilename))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "task-info-percent" }, [
              item.itemProgressInfo &&
              item.itemProgressInfo.percent &&
              item.itemProgressInfo.percent != 100 &&
              item.itemProgressInfo.percent != 0.0
                ? _c("div", [
                    _vm._v(_vm._s(item.itemProgressInfo.percent) + "%"),
                    item.itemProgressInfo && item.itemProgressInfo.speed
                      ? _c("span", [
                          _vm._v(
                            "(" + _vm._s(item.itemProgressInfo.speed) + ")"
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "task-info-speed" }, [
              _vm.hoverCurrent == index
                ? _c("div", {
                    staticClass: "icon-util taskinfo-collapse-position",
                    class: item.open ? "collapse-up" : "collapse-down"
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.hoverCurrent == index &&
              item.status < 3 &&
              item.errorList &&
              !item.errorList.length &&
              (!item.itemProgressInfo || item.itemProgressInfo.percent != 100)
                ? _c("div", {
                    staticClass:
                      "icon-util purple-cancel taskinfo-cancel-position",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.cancelPasteTask(item, index)
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                item.status < 3 ||
                item.status == "ready" ||
                (item.itemProgressInfo &&
                  item.itemProgressInfo.status == "ready" &&
                  item.errorList &&
                  !item.errorList.length)
                  ? _c("transferingDetail", {
                      attrs: { open: item.open, index: index, itemDetail: item }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getTaskStr(item) == "success"
                  ? _c("successDetail", {
                      attrs: { open: item.open, index: index, itemDetail: item }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getTaskStr(item) == "error" ||
                _vm.getTaskStr(item) == "success8"
                  ? _c("unfinishedDetail", {
                      attrs: { open: item.open, index: index, itemDetail: item }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57e59fef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e59fef","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_detailed_progress/tab_all_tasks.vue
// module id = null
// module chunks = 